module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n\nvar commonMsg = require(\'@cdo/locale\');\nvar mazeMsg = require(\'.././locale\');\n\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar level = locals.level;\n\nvar addProcedures = function() { -%>\n  <% if (level > 3) { -%>\n    <category name="<%= commonMsg.catProcedures() %>" custom="PROCEDURE"></category>\n  <% } else if (level === 2 || level === 3) { -%>\n    <category name="<%= commonMsg.catProcedures() %>">\n      <block type="procedures_callnoreturn">\n        <mutation name="<%= mazeMsg.fillN({shovelfuls: 5}) %>"></mutation>\n      </block>\n    </category>\n  <% } -%>\n  <% if (level < 9) { -%>\n    <category name="<%= commonMsg.catLogic() %>">\n      <block type="karel_if"></block>\n    </category>\n  <% } else if (level > 8) { -%>\n    <category name="<%= commonMsg.catLogic() %>">\n      <block type="karel_if"></block>\n      <block type="karel_ifElse"></block>\n    </category>\n  <% } -%>\n<% }; -%>\n\n<xml id="toolbox" style="display: none;">\n  <category name="<%= commonMsg.catActions() %>">\n    <block type="maze_moveForward"></block>\n    <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n    <block type="maze_turn"><title name="DIR">turnRight</title></block>\n    <block type="maze_dig"></block>\n    <block type="maze_fill"></block>\n  </category>\n  <% addProcedures() -%>\n  <category name="<%= commonMsg.catLoops() %>">\n    <block type="maze_untilBlocked"></block>\n    <block type="controls_repeat"></block>\n  </category>\n</xml>\n', __filename = "src/maze/toolboxes/karel2.xml.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var commonMsg = require("@cdo/locale");
        var mazeMsg = require(".././locale");
        var level = locals.level;
        var addProcedures = function() {
            __line = 11;
            __append("  ");
            __line = 12;
            if (level > 3) {
                __append('    <category name="');
                __line = 13;
                __append(escapeFn(commonMsg.catProcedures()));
                __append('" custom="PROCEDURE"></category>\n  ');
                __line = 14;
            } else if (level === 2 || level === 3) {
                __append('    <category name="');
                __line = 15;
                __append(escapeFn(commonMsg.catProcedures()));
                __append('">\n      <block type="procedures_callnoreturn">\n        <mutation name="');
                __line = 17;
                __append(escapeFn(mazeMsg.fillN({
                    shovelfuls: 5
                })));
                __append('"></mutation>\n      </block>\n    </category>\n  ');
                __line = 20;
            }
            __append("  ");
            __line = 21;
            if (level < 9) {
                __append('    <category name="');
                __line = 22;
                __append(escapeFn(commonMsg.catLogic()));
                __append('">\n      <block type="karel_if"></block>\n    </category>\n  ');
                __line = 25;
            } else if (level > 8) {
                __append('    <category name="');
                __line = 26;
                __append(escapeFn(commonMsg.catLogic()));
                __append('">\n      <block type="karel_if"></block>\n      <block type="karel_ifElse"></block>\n    </category>\n  ');
                __line = 30;
            }
            __line = 31;
        };
        __append('\n<xml id="toolbox" style="display: none;">\n  <category name="');
        __line = 34;
        __append(escapeFn(commonMsg.catActions()));
        __append('">\n    <block type="maze_moveForward"></block>\n    <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n    <block type="maze_turn"><title name="DIR">turnRight</title></block>\n    <block type="maze_dig"></block>\n    <block type="maze_fill"></block>\n  </category>\n  ');
        __line = 41;
        addProcedures();
        __append('  <category name="');
        __line = 42;
        __append(escapeFn(commonMsg.catLoops()));
        __append('">\n    <block type="maze_untilBlocked"></block>\n    <block type="controls_repeat"></block>\n  </category>\n</xml>\n');
        __line = 47;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}